const config = {
    baseUrl: "https://marisa.symloop.com/api/listing" ,
    imageBaseUrl: "https://marisa.symloop.com", // Base URL for images without /api
    userService: "https://marisa.symloop.com"
};
  
  export default config;